import React from 'react';
import { Check, Brain, Target, MessageCircle, Users, Bot, Calendar } from 'lucide-react';
import { motion } from 'framer-motion';
const modules = [{
  icon: Brain,
  title: 'Mentalidad y Primeros Pasos del Corredor',
  desc: 'Setea tu cabeza para el éxito. Cómo presentarte, armar tu propuesta de valor y vencer el síndrome del impostor en tus primeras reuniones.'
}, {
  icon: Target,
  title: 'Sistema de Captación de Tu Primera Cartera',
  desc: 'Estrategias probadas para conseguir tus primeras propiedades en exclusiva, sin depender únicamente de familiares y amigos.'
}, {
  icon: MessageCircle,
  title: 'Cierre de Objeciones para Tu Primera Venta PRO',
  desc: "El manual exacto para rebatir el 'es muy caro', 'lo quiero pensar' y 'otro me cobra menos comisión'."
}, {
  icon: Users,
  title: 'Gestión de Clientes Sin Experiencia Previa',
  desc: 'Cómo llevar el proceso de compra-venta transmitiendo seguridad y profesionalismo absoluto, aunque sea tu primera vez.'
}, {
  icon: Bot,
  title: 'Automatización de Trámites con IA',
  desc: 'Usa inteligencia artificial para redactar descripciones de propiedades, mails a escribanías y organizar tu agenda en minutos.'
}, {
  icon: Calendar,
  title: 'Plan 90 Días: De Recién Recibido a Corredor Activo',
  desc: 'Tu hoja de ruta semana a semana. Qué hacer el día 1, el día 30 y el día 90 para asegurar tracción real.'
}];
export function ModuleDetails() {
  return <section className="py-24 bg-white px-6 lg:px-8" data-id="element-161">
      <div className="max-w-6xl mx-auto" data-id="element-162">
        <div className="text-center mb-16" data-id="element-163">
          <h2 className="text-3xl md:text-5xl font-extrabold text-brand-navy mb-4" data-id="element-164">
            ¿Qué hay dentro del Megapack?
          </h2>
          <p className="text-xl text-brand-navy/70" data-id="element-165">
            El paso a paso desglosado.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20" data-id="element-166">
          {modules.map((mod, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-lighter rounded-2xl p-8 border border-brand-light hover:shadow-soft transition-all" data-id="element-167">
              <div className="w-14 h-14 rounded-xl bg-brand-accent/10 flex items-center justify-center mb-6" data-id="element-168">
                <mod.icon className="w-7 h-7 text-brand-accent" data-id="element-169" />
              </div>
              <div className="text-sm font-bold text-brand-accent mb-2" data-id="element-170">
                MÓDULO {i + 1}
              </div>
              <h3 className="text-xl font-bold text-brand-navy mb-4 leading-tight" data-id="element-171">
                {mod.title}
              </h3>
              <p className="text-brand-navy/70" data-id="element-172">{mod.desc}</p>
            </motion.div>)}
        </div>

        <div className="bg-brand-navy rounded-3xl p-8 md:p-12 text-white relative overflow-hidden" data-id="element-173">
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-accent/20 rounded-full blur-3xl -mr-20 -mt-20" data-id="element-174"></div>

          <h3 className="text-2xl font-bold mb-8 text-center relative z-10" data-id="element-175">
            Cada módulo incluye por defecto:
          </h3>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 relative z-10" data-id="element-176">
            {['Guion listo para usar', 'Plantilla editable', 'Ejemplos reales', 'Checklist de aplicación'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-white/10 rounded-xl p-4 backdrop-blur-sm" data-id="element-177">
                <div className="w-6 h-6 rounded-full bg-brand-green flex items-center justify-center shrink-0" data-id="element-178">
                  <Check className="w-4 h-4 text-white" data-id="element-179" />
                </div>
                <span className="font-medium" data-id="element-180">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}